var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cf"},[_vm._v(" 梧州市群艺馆文化云终端 ")]),_c('md-button',{attrs:{"type":"primary"},on:{"click":_vm.sendOk}},[_vm._v("确定提交信息")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }